import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WifiLockIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wifi_lock"}/>
}
